import {
  getOrganizationTimezone,
  updateOrganizationTimezone,
} from "@/api/organization";
import { useUser } from "@clerk/clerk-react";
import { Button, ConfigProvider, message } from "antd";
import { useEffect, useState } from "react";
import TimezoneSelect, { type ITimezone } from "react-timezone-select";
import { useTranslation } from "react-i18next";

export const Timezone = () => {
  const { t } = useTranslation();
  const { user, isLoaded } = useUser();
  const [messageApi, contextHolder] = message.useMessage();
  const defaultTimezoneInBrowser =
    Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [selectedTimezone, setSelectedTimezone] = useState<any>();

  useEffect(() => {
    if (isLoaded && user && !user?.unsafeMetadata?.timezone) {
      user.update({
        unsafeMetadata: {
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
      });
    }
  }, [isLoaded, user]);

  useEffect(() => {
    if (isLoaded && user) {
      setSelectedTimezone(
        user?.unsafeMetadata?.timezone || defaultTimezoneInBrowser
      );
    }
  }, [isLoaded, user, defaultTimezoneInBrowser]);

  if (!isLoaded || !user) {
    return <div>{t("components.timezone.loading")}</div>;
  }

  return (
    <ConfigProvider
    theme={{
      token: {
        colorPrimary: "#c4330a",
      }
    }}
    >

    <div className="mt-8">
      {contextHolder}
      <div className="select-wrapper">
        <TimezoneSelect
          value={selectedTimezone}
          onChange={setSelectedTimezone}
        />
      </div>
      <Button
        className="mt-4"
        type="primary"
        onClick={() => {
          try {
            user.update({
              unsafeMetadata: {
                timezone: selectedTimezone,
              },
            });
            messageApi.success(t("components.timezone.timezoneSaved"));
          } catch (error) {
            messageApi.error(t("components.timezone.timezoneSaveFailed"));
          }
        }}
      >
       {t("components.timezone.save")}
      </Button>
    </div>
</ConfigProvider>
  );
};

export const OrganizationTimezone = () => {
  const { t } = useTranslation();
  const [isInitLoading, setIsInitLoading] = useState(true);
  const defaultTimezoneInBrowser =
    Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [selectedTimezone, setSelectedTimezone] = useState<any>();
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    const initTimezone = async () => {
      const { timezone } = await getOrganizationTimezone();
      setIsInitLoading(false);
      if (!timezone) {
        setSelectedTimezone(defaultTimezoneInBrowser);
        await updateOrganizationTimezone(defaultTimezoneInBrowser);
      } else {
        setSelectedTimezone(timezone);
      }
    };

    initTimezone();
  }, []);

  if (isInitLoading) {
    return <div>{t("components.timezone.loading")}</div>;
  }

  return (
    <div>
      {contextHolder}
      <div className="select-wrapper">
        <TimezoneSelect
          value={selectedTimezone}
          onChange={setSelectedTimezone}
        />
      </div>
      <Button
        className="mt-4"
        type="primary"
        onClick={async () => {
          try {
            messageApi.success(t("components.timezone.timezoneSaved"));
            await updateOrganizationTimezone(selectedTimezone.value);
          } catch (error) {
            messageApi.error(t("components.timezone.timezoneSaveFailed"));
          }
        }}
      >
        {t("components.timezone.save")}
      </Button>
    </div>
  );
};
